import { useEffect } from 'react';
import { FormLabel, Grid, Stack } from '@mui/material';
import { useDispatch } from 'react-redux';
import { RefinementListSelect } from '@/components/selects/RefinementListSelect';
import { RelationshipContactStatusSelect } from '@/components/selects/RelationshipContactStatusSelect';
import { useGridItemProps } from '@/components/table/filterGrid';
import RelationshipTableFilters from '@/components/tables/RelationshipTableFilters';
import { setFilters } from '@/features/table/instantSearchSlice';
import { useInstantSearchOwnerFilters } from '@/hooks/useInstantSearchOwnerFilters';
import { toRelationshipContactStatuses } from '@/utils/relationshipContactOptions';

const RelationshipContactsTableFilters = () => {
	const dispatch = useDispatch();
	const { generalGridProps } = useGridItemProps();
	const { slug, filters } = useInstantSearchOwnerFilters();
	const relationshipStatus = toRelationshipContactStatuses(filters.relationshipStatus);

	useEffect(() => {
		if (filters.relationshipStatus) {
			return;
		}
		dispatch(
			setFilters({
				slug,
				type: 'relationshipStatus',
				values: relationshipStatus,
			}),
		);
	}, [dispatch, filters.relationshipStatus, relationshipStatus, slug]);

	return (
		<RelationshipTableFilters ownerLabel='Created by'>
			<Grid {...generalGridProps}>
				<Stack direction='column' width='100%'>
					<FormLabel>Type</FormLabel>
					<RefinementListSelect attribute='relationshipType' multiple disableTooltip />
				</Stack>
			</Grid>
			<Grid {...generalGridProps}>
				<RelationshipContactStatusSelect
					width='100%'
					filters={{ relationshipStatus }}
					onFilterChange={({ relationshipStatus }) =>
						dispatch(
							setFilters({
								slug,
								type: 'relationshipStatus',
								values: relationshipStatus,
							}),
						)
					}
				/>
			</Grid>
		</RelationshipTableFilters>
	);
};

export default RelationshipContactsTableFilters;
